const producer = state => state.producer
const producers = state => state.producers

export default {
  producer,
  producers

}
